"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DropdownParent_1 = require("../../Internal/DropdownParent/DropdownParent");
var Localization_1 = require("../../Localization");
var EntryPicker_styles_1 = require("./EntryPicker.styles");
var EntryPickerLarge_1 = require("./EntryPickerLarge");
var ToggleContent_1 = require("./ToggleContent");
exports.default = (function (_a) {
    var AriaLabel = _a.AriaLabel, HasErrors = _a.HasErrors, ID1HeaderText = _a.ID1HeaderText, ID2HeaderText = _a.ID2HeaderText, ID3HeaderText = _a.ID3HeaderText, IsDisabled = _a.IsDisabled, IsRequired = _a.IsRequired, LabelledBy = _a.LabelledBy, OnBlur = _a.OnBlur, OnChange = _a.OnChange, OnClearSearch = _a.OnClearSearch, OnSearch = _a.OnSearch, SaveGridLayoutID = _a.SaveGridLayoutID, SelectedEntry = _a.Value, Width = _a.Width;
    var _b = React.useState({
        IsLoading: false,
    }), state = _b[0], setState = _b[1];
    var handleSearch = function (searchFor) {
        setState(__assign(__assign({}, state), { CurrentSearchValue: searchFor, IsLoading: true }));
        OnSearch(searchFor).then(function (results) {
            setState(__assign(__assign({}, state), { CurrentItems: results, CurrentSearchValue: searchFor, IsLoading: false }));
        });
    };
    var handleSearchClear = function () {
        setState(__assign(__assign({}, state), { CurrentItems: [], CurrentSearchValue: "" }));
        OnChange(undefined);
        if (OnClearSearch) {
            OnClearSearch();
        }
    };
    var EmptyStateMessage = React.forwardRef(function (_a, _) {
        var Text = _a.Text;
        return React.createElement(EntryPicker_styles_1.EmptyStateP, null, Text);
    });
    var DropdownMenuContent = React.forwardRef(function (props, ref) {
        var SetDropdownVisibility = React.useContext(DropdownParent_1.DropdownParentContext).SetDropdownVisibility;
        var handleSelectedItemChanged = function (entry) {
            OnChange(entry);
            SetDropdownVisibility(false);
        };
        // There are three things which can return:
        // 1. If there is a selected Entry then message explaining to clear first then search
        // 2. If this is clean/empty state then a message explaining to type in a search to get results
        // 3. If these is valid search input then the results grid.
        var getContent = function () {
            if (SelectedEntry) {
                return React.createElement(EmptyStateMessage, { ref: ref, Text: Localization_1.strings.EntryPicker_Message_SelectedEntryInfo });
            }
            else if (!state.IsLoading && (!state.CurrentItems || !state.CurrentItems.length) && !state.CurrentSearchValue) {
                return React.createElement(EmptyStateMessage, { ref: ref, Text: Localization_1.strings.EntryPicker_Message_InitialSearchInfo });
            }
            return (React.createElement(EntryPickerLarge_1.EntryPickerLarge, __assign({}, props, { Data: state.CurrentItems, IsLoading: state.IsLoading, ID1HeaderText: ID1HeaderText, ID2HeaderText: ID2HeaderText, ID3HeaderText: ID3HeaderText, SaveGridLayoutID: SaveGridLayoutID, ref: ref, OnSelectedItemChanged: handleSelectedItemChanged })));
        };
        return (getContent());
    });
    return (React.createElement(DropdownParent_1.default, { DropdownToggleContent: React.forwardRef(function (props, ref) { return (React.createElement(ToggleContent_1.ToggleContent, __assign({}, props, { ref: ref, OnSearch: handleSearch, OnClearSearch: handleSearchClear, AriaLabel: AriaLabel, LabelledBy: LabelledBy, SearchValue: state.CurrentSearchValue, SelectedEntry: SelectedEntry, IsRequired: IsRequired, IsDisabled: IsDisabled }))); }), DropdownMenuContent: DropdownMenuContent, DropdownWidth: Width, HasErrors: HasErrors, IsDisabled: IsDisabled, OnBlur: OnBlur }));
});
